import styles from './Slide5.module.css';
import SlideShell from './SlideShell';

export default function Slide5({ handleNext, handlePrev, current, total, t }) {
  return (
    <SlideShell handleNext={handleNext} handlePrev={handlePrev} current={current} total={total} t={t}>
      <div className={styles.wrapper}>
        <img src='/assets/intro/letStart.png' alt='' className={styles.image}/>
        <div className={styles.header}>
          <p className={styles.title}>{t("intro_child_favorite_place_start_title")}</p>
          <p className={styles.text}>{t("intro_onboarding_ready_explore_message")}</p>
        </div>
      </div>
    </SlideShell>
  );
}